import React from 'react'
import {
  initialWindowMetrics,
  SafeAreaProvider,
} from 'react-native-safe-area-context'
import Dripsy from './Dripsy'
import { NavigationProvider } from './Navigation'
import { ActionSheetProvider } from '@expo/react-native-action-sheet'
import { OpenAPI } from '@beatgig/api-services'
import Doorman from './Doorman'
import SentryProvider from './Sentry'
import NextRouterProvider from './Router'
import dynamic from 'next/dynamic'
import VERSION from '@beatgig/helpers/version'

const Popups = dynamic(() => import('./popups'), { ssr: false })
const IntercomChat = dynamic(() => import('@beatgig/components/intercom'), {
  ssr: false,
})
const NotifierWrapper = dynamic(
  () =>
    import('react-native-notifier').then((module) => module.NotifierWrapper),
  { ssr: false }
)

type Props = {
  children: React.ReactNode
}

console.log({ VERSION })

export default function Providers(props: Props) {
  const { children } = props

  if (
    typeof process !== 'undefined' &&
    typeof process.env !== 'undefined' &&
    process.env.NODE_ENV !== 'production' &&
    typeof process.env.OPEN_API_ENDPOINT === 'string'
  ) {
    OpenAPI.BASE = process.env.OPEN_API_ENDPOINT
    console.log('👋 [dev-mode][providers] Open API endpoint:', OpenAPI.BASE)
  }
  return (
    <SentryProvider>
      <SafeAreaProvider initialMetrics={initialWindowMetrics}>
        <Dripsy>
          <Doorman>
            <NavigationProvider>
              {/* <PreloadAssets> */}
              <ActionSheetProvider>
                <NextRouterProvider>
                  <Popups>
                    <NotifierWrapper>{children}</NotifierWrapper>
                  </Popups>
                </NextRouterProvider>
              </ActionSheetProvider>
              {/* </PreloadAssets> */}
            </NavigationProvider>
          </Doorman>
        </Dripsy>
      </SafeAreaProvider>
    </SentryProvider>
  )
}
